import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
const API_URL = environment.apiUrl;

@Injectable({
  providedIn: 'root'
})
export class MembershipService {

  constructor(private http: HttpClient) { }

  addMembership(data) {
    return this.http.post(`${API_URL}membership`,data);
  }

  updateMembership(data, id) {
    return this.http.put(`${API_URL}membership/${id}`,data);
  }

  getMembershipById(id:string) {
    return this.http.get(`${API_URL}membership/${id}`);
  }

  getAllMembership(query:string) {
    return this.http.get(`${API_URL}membership${query}`);
  }
}
